import React, { useMemo } from "react";
import { Box, Container, IconButton, Typography, Paper } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useLocation, useNavigate } from "react-router-dom";

function Page({ title, actions = null, backTo = null, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const computedBackTo = useMemo(() => {
    if (backTo) return backTo;

    const segments = location.pathname.split("/").filter(Boolean);
    const cabinetIndex = segments.indexOf("cabinet");
    if (cabinetIndex === -1) return null;
    const afterCabinet = segments.slice(cabinetIndex + 1);
    if (afterCabinet.length <= 1) return null;
    const sectionRoot = "/" + segments.slice(0, cabinetIndex + 2).join("/");
    return sectionRoot || null;
  }, [backTo, location.pathname]);

  const showBack = Boolean(computedBackTo);

  return (
    <Container
      maxWidth={false}
      sx={{ padding: "15px 0", maxWidth: 1280, mx: "auto" }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mt: 1,
          mb: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {showBack && (
            <IconButton
              aria-label="Назад"
              onClick={() => navigate(computedBackTo)}
              size="small"
              color="primary"
            >
              <ArrowBackIosNewIcon />
            </IconButton>
          )}
          <Typography variant={"h5"} component={"h1"} sx={{ fontWeight: 500 }}>
            {title}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {actions}
        </Box>
      </Box>
      <Paper elevation={0} sx={{ p: 2, borderRadius: 2, bgcolor: "#ffffff" }}>
        {children}
      </Paper>
    </Container>
  );
}

export default Page;
